import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FeatureFlags } from '@mobi/settings'
import { useFeature, useLogon } from '@core/Utils/hooks'
import { Banner } from '@core/Components/Banner'
import { OffersTab } from '@core/Areas/VenueMode/Components/Offers/OffersTab'
import { Racing } from '@core/Areas/VenueMode/Components/Racing/Racing'
import { Notices } from '@core/Areas/VenueMode/Components/Notices/Notices'
import { LoggedOut } from '@core/Areas/VenueMode/Components/LoggedOut/LoggedOut'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { Drawer } from '@mobi/component-library/Overlays/Drawer'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { MainContainer } from '@core/Components/Containers'
import { VENUE_FEATURE_NAME } from '@core/Areas/VenueMode/constants'
import { getCoords } from '@core/Areas/VenueMode/Store'
import { Diagnostics } from './Components/Diagnostics/Diagnostics'
import { ContentContainerStyled } from './VenueMode.styles'

export const VenueMode = (): React.JSX.Element => {
  const geoLocation = useSelector(getCoords)
  const isVenueModeDiagnosticsFeatureActive = useFeature(FeatureFlags.VENUE_MODE_DIAGNOSTICS.key)
  const { isLoggedIn } = useLogon()
  const [isDiagnosticsOpen, setIsDiagnosticsOpen] = useState(false)

  return (
    <MainContainer background='surface300'>
      <PageHeader
        title={VENUE_FEATURE_NAME}
        subTitle={geoLocation.closestVenue?.inside == true ? geoLocation.closestVenue?.name : ''}
        rightAlignedComponent={
          isVenueModeDiagnosticsFeatureActive && (
            <Icon name='LineHelpCircle' size='3rem' onClick={() => setIsDiagnosticsOpen(true)} />
          )
        }
      />

      <Banner areaName='Venue' />

      <Notices />

      <ContentContainerStyled>
        <OffersTab />
        {!isLoggedIn ? <LoggedOut /> : <Racing />}
      </ContentContainerStyled>

      <Drawer
        isOpen={isDiagnosticsOpen}
        shouldUseBodyScrollLock
        onDismiss={() => setIsDiagnosticsOpen(false)}
      >
        <Diagnostics />
      </Drawer>
    </MainContainer>
  )
}
